// Funkcja do zamiany liczb na słowa (polski, liczby do 999 999)
const jednostki = [
  '',
  'jeden',
  'dwa',
  'trzy',
  'cztery',
  'pięć',
  'sześć',
  'siedem',
  'osiem',
  'dziewięć'
]
const nastki = [
  'dziesięć',
  'jedenaście',
  'dwanaście',
  'trzynaście',
  'czternaście',
  'piętnaście',
  'szesnaście',
  'siedemnaście',
  'osiemnaście',
  'dziewiętnaście'
]
const dziesiatki = [
  '',
  '',
  'dwadzieścia',
  'trzydzieści',
  'czterdzieści',
  'pięćdziesiąt',
  'sześćdziesiąt',
  'siedemdziesiąt',
  'osiemdziesiąt',
  'dziewięćdziesiąt'
]
const setki = [
  '',
  'sto',
  'dwieście',
  'trzysta',
  'czterysta',
  'pięćset',
  'sześćset',
  'siedemset',
  'osiemset',
  'dziewięćset'
]

function grupa(n: number, zlp: [string, string, string]): string {
  let s = ''

  const s1 = Math.floor(n / 100)
  const s2 = Math.floor((n % 100) / 10)
  const s3 = n % 10

  if (n === 0) return ''

  if (s1 > 0) s += setki[s1] + ' '
  if (s2 === 1) {
    s += nastki[s3] + ' '
  } else {
    if (s2 > 1) s += dziesiatki[s2] + ' '
    if (s3 > 0) s += jednostki[s3] + ' '
  }
  // końcówka rzeczownika
  if (n === 1) return (s + zlp[0]).trim()
  if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20))
    return (s + zlp[1]).trim()
  return (s + zlp[2]).trim()
}

export function slownie(kwota: number): string {
  kwota = Math.round(kwota * 100) / 100
  const zl = Math.floor(kwota)
  const gr = Math.round((kwota - zl) * 100)

  let tekst = ''
  const tys = Math.floor(zl / 1000)
  const jed = zl % 1000

  if (tys > 0) {
    tekst += grupa(tys, ['tysiąc ', 'tysiące ', 'tysięcy '])
    tekst += ' '
  }
  tekst += grupa(jed, ['złoty', 'złote', 'złotych'])

  if (zl === 0) tekst = 'zero złotych'
  tekst = tekst.trim()

  // grosze
  tekst += ' '

  if (gr > 0) {
    tekst += grupa(gr, ['grosz', 'grosze', 'groszy'])
  } else {
    tekst += 'zero groszy'
  }

  return tekst.trim()
}
